import {AfterViewInit, Component, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {interval, Observable, ReplaySubject} from 'rxjs';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {AuthService} from '../../../../shared/services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FilterService} from '../../../../shared/services/filter.service';
import {select, Store} from '@ngrx/store';
import {StoreRootState} from '../../../../shared/ngrx/reducers';
import {delay, distinctUntilChanged, first, startWith, takeUntil, tap} from 'rxjs/operators';
import {CountedAndPaginated} from '../../../../shared/interface/response/counted-and-paginated';
import {getCurrentRouteState} from '../../../../shared/ngrx/selector';
import {RouterStateUrl} from '../../../../shared/ngrx/route-serializer';
import {Uuid} from '../../../../shared/interface/response/uuid';
import {JobResultDialogComponent} from '../../../../shared/components/job-result-dialog/job-result-dialog.component';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Invoice} from '../../../../shared/interface/invoice';
import {InvoiceService} from '../../../../shared/services/invoice.service';
import {PaymentService} from '../../../../shared/services/payment.service';
import {PaymentJobService} from "../../../../shared/services/payment-job.service";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import {DOCUMENT} from "@angular/common";
import {CommissionJobService} from "../../../../shared/services/commission-job.service";
import moment from "moment/moment";
import {CommissionJob} from "../../../../shared/interface/commission-job";
import {Sort} from "@angular/material/sort";
import {INVOICE_STATUS_SUSPENDED, INVOICE_STATUS_TO_BE_REALIZED} from "../../../../shared/services/dict.service";


@Component({
  selector: 'app-all-payment-list',
  templateUrl: './all-payment-list.component.html',
  styleUrls: ['./all-payment-list.component.scss']
})
export class AllPaymentListComponent implements AfterViewInit, OnInit, OnDestroy {
  @Input() embeddedView = false;

  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() statusKey?: string[] = null;
  @Input() companyKey?: number =  null;

  initialFilters: any;
  items: Invoice[] = [];
  displayedColumns: string[] = [
    'billingMonth', 'company', 'number', 'party', 'contractOwner', 'status', 'net', 'payoutNet',
  ];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  actionForm: FormGroup;
  actionKeyControl: FormControl;
  billingMonthControl: FormControl;
  importControl: FormControl;
  statusKeyControl: FormControl;
  partnerControl: FormControl;
  ofwcaControl: FormControl;
  numberOfInvoicesOnHold = 0;
  numberOfInvoicesToBeProcessed  = 0;
  sortBy = 'number';
  sortOrder = 'desc';
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private httpClient: HttpClient,
    private paymentJobService: PaymentJobService,
    private invoiceService: InvoiceService,
    private paymentService: PaymentService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private filterService: FilterService,
    private store: Store<StoreRootState>,
    private router: Router,
    private commissionJobService: CommissionJobService,
    private fb: FormBuilder,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.paymentService.getPaymentListSubject()
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<Invoice>) => {
          this.items = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();

    const date = moment();
    date.startOf('month');
    date.subtract(1, 'month');
    this.billingMonthControl = fb.control(date, [Validators.required]);

    // this.actionForm = fb.group({
    //   billingMonth: this.billingMonthControl,
    //   statusKey: this.statusKey,
    //   parnter: this.partnerControl,
    //   ofwca: this.ofwcaControl,
    // });
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      billingMonth: 'date',
      contains$number: 'string',
      ofwca: 'string',
      partner: 'string',
      status: 'int',
      gte$net: 'string',
      lte$net: 'string',
      assetsRegional: 'string',
      action: 'int',
      company: 'int',
      contractType: 'int',
      owner: 'string',
      selfBilling: 'int',
      automaticSettlement: 'int',
      generatedManually: 'int'
    }, filters);
  }
  ngOnInit(): void {
    interval(5000)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        if (this.paginator.pageIndex === 0) {
          this.loadPaymentList();
        }
      });
    this.billingMonthControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((billingMonth) => {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          page: this.paginator.pageIndex,
          pageSize: this.paginator.pageSize,
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          billingMonth,
          ...this.initialFilters,
        })]);
      });
  }
  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        billingMonth: this.billingMonthControl.value,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
        ...this.filtersForm.value
      })]);
    });

    this.activatedRoute.data
      .pipe(
        delay(0),
        first()
      )
      .subscribe((data: any) => {
        this.statusKey = this.statusKey ?? data.statusKey ?? null;
        this.companyKey = this.companyKey ?? data.companyKey ?? null;
        this.displayedColumns = data.displayedColumns ?? this.displayedColumns;
     });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        if (state.params?.billingMonth) {
          this.billingMonthControl.setValue(moment(state.params.billingMonth));
        }
        this.sortBy = state.params?.sortBy ? state.params.sortBy : 'number';
        this.sortOrder = state.params?.sortOrder ? state.params.sortOrder : 'desc';
        this.loadPaymentList();
      });
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      billingMonth: this.billingMonthControl.value,
      ...this.filtersForm.value,
    })]);
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};
    if (null !== this.statusKey) {
      filters.statusKey = this.statusKey;
    }
    if (null !== this.companyKey) {
      filters.companyKey = this.companyKey;
    }
    return filters;
  }
  loadListData(): void {
    this.paymentJobService.loadJobList(this.paginator.pageIndex, this.paginator.pageSize, this.buildFilters());
  }
  numberOfInvoicesToBeProcessedFun(): number{
    return this.paymentService.getNumberOfInvoicesToBeProcessed();
  }
  numberOfInvoicesOnHoldFun(): number{
    return  this.paymentService.getNumberOfInvoicesOnHold();
  }
  buildFiltersNumber(key: string): any {
    const filters = {...this.initialFilters};
      filters.statusKey = [key];

    if (null !== this.companyKey) {
      filters.companyKey = this.companyKey;
    }
    return filters;
  }

  loadPaymentList(): void {
    this.paymentService.loadPaymentList(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.buildFilters(),
      {
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      });
    this.paymentService.loadPaymentNumberOfInvoices(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.buildFiltersNumber(INVOICE_STATUS_TO_BE_REALIZED),
      this.buildFiltersNumber(INVOICE_STATUS_SUSPENDED));
  }
  downloadReport(): void {
    this.invoiceService.downloadReport(this.buildFilters(), {sortBy: this.sortBy, sortOrder: this.sortOrder})
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  // generatePayment(): void {
  //   const dialogRef = this.dialog.open(ConfirmDialogComponent, {
  //     width: '500px',
  //     data: {text: 'Czy na pewno chcesz uruchomić tę akcję?'},
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //       if (result) {
  //         this.paymentJobService.generatePayment(this.actionForm.value)
  //           .subscribe(() => {
  //             this.loadListData();
  //           }, (error: HttpErrorResponse) => {
  //             this.snack.open('Przy generowaniu pliku do banku wystąpił błąd', error.status.toString(), {duration: 2000});
  //           });
  //       }
  //     }
  //   );
  // }
//   generatePayment(): void {
//     const dialogRef = this.dialog.open(ConfirmDialogComponent, {
//           width: '500px',
//           data: {text: 'Czy na pewno chcesz uruchomić tę akcję?'},
//         });
//         dialogRef.afterClosed().subscribe(result => {
//           if (result) {
//             this.paymentJobService.generatePayment(this.initialFilters)
//               .subscribe((response: Invoice) => {
//                 this.dialog.open(JobResultDialogComponent, {
//                   width: '500px',
//                   data: {jobId: response.status, showProgress: false},
//                 });
//               }, (error: HttpErrorResponse) => {
//                 this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
//               });
//             }
//           }
//         );
// }
  generatePayment(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz uruchomić tę akcję?'},
    });
    dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.paymentService.downloadPaymentList(this.buildFilters(), {sortBy: this.sortBy, sortOrder: this.sortOrder})
            .subscribe((response: Uuid) => {
              this.dialog.open(JobResultDialogComponent, {
                disableClose: true,
                width: '500px',
                data: {jobId: response.uuid, showProgress: false},
              });
            }, (error: HttpErrorResponse) => {
              this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
            });
        }
      }
    );
  }
  // generatePayment(): void {
  //   this.paymentJobService.generatePayment(this.initialFilters)
  //     .subscribe((response: Invoice) => {
  //       this.dialog.open(JobResultDialogComponent, {
  //         width: '500px',
  //         data: {jobId: response.status, showProgress: false},
  //       });
  //     }, (error: HttpErrorResponse) => {
  //       this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
  //     });
  // }


  importPayment(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz uruchomić tę akcję?'},
    });
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }

  sortChanged($event: Sort): void {
    this.sortBy = $event.active;
    this.sortOrder = $event.direction;

    if (!this.embeddedView) {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        sortBy: $event.active,
        sortOrder: $event.direction,
        page: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
        ...this.filtersForm.value
      })]);
    } else {
      this.loadListData();
    }
  }

}
